const initialState = {
	confirmRequested: false,
	title: null,
	text: null,
	callback: null,
	textYes: null,
	textNo: null,
	answerYes: true,
	answerNo: false
};


export default {
	state: {
		...initialState
	},

	mutations: {

		set (state, options) {
			const init = Object.assign({}, initialState, options);
			for (let prop in init) {
				state[prop] = init[prop];
			}
		},

		clear (state) {
			for (let prop in initialState) {
				state[prop] = initialState[prop];
			}
		},

		answer (state, answer) {
			if (state.callback instanceof Function) {
				state.callback(answer? state.answerYes : state.answerNo);
			}
		}

	},

	actions: {

		requestConfirmation({ state, commit }, opts = { answerYes: true, answerNo: false }) {
			commit('set', { ...opts, confirmRequested: true });
		},

		yes ({ state, commit }) {
			commit('answer', true);
			commit('clear')
		},

		no ({ state, commit }) {
			commit('answer', false);
			commit('clear')
		},

		confirmDelete({ dispatch }, callback) {
			dispatch('requestConfirmation', {
				callback,
				title: "Delete entity",
				text: "If you proceed, this entity will be permanently deleted. Please confirm or cancel.",
				textYes: "Delete",
				textNo: "Cancel",
				answerYes: true,
				answerNo: false
			});
		}
	},

	namespaced: true
};



// WEBPACK FOOTER //
// ./src/store/modules/dialogue/confirm.js